import { render, staticRenderFns } from "./firm-detail-view.vue?vue&type=template&id=2b3d3436&scoped=true&"
import script from "./firm-detail-view.vue?vue&type=script&lang=js&"
export * from "./firm-detail-view.vue?vue&type=script&lang=js&"
import style0 from "./firm-detail-view.vue?vue&type=style&index=0&id=2b3d3436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d3436",
  null
  
)

export default component.exports